/** Presentation only: keep stored names, URLs and owner-authored SEO unchanged. */
export function formatOrganizationDisplayName(name: string): string {
  return name.normalize('NFKC')
    .replace(/[\p{Pd}_]+/gu, ' ')
    .replace(/[^\p{L}\p{M}\p{N}\s]/gu, '')
    .trim()
    .replace(/\s+/gu, ' ')
    .replace(/(^|\s)(\p{L})/gu, (_match, space: string, letter: string) => space + letter.toUpperCase())
    .replace(/(^|\s)rn(?=\s|$)/giu, '$1RN') || 'Organization';
}
